import ImageCTA from "./ImageCTA";

export default ImageCTA;
